enum MessageModificators {
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL',
    LOG = 'LOG'
}

const localLogger = {
    [MessageModificators.CRITICAL]: console.trace,
    [MessageModificators.ERROR]: console.error,
    [MessageModificators.LOG]: console.log,
    [MessageModificators.WARNING]: console.warn
};

class Logger {
    private get isProduction() {
        return process.env.NODE_ENV !== 'development';
    }
    addEvent(modificator: MessageModificators, message: any, error: any) {
        if (this.isProduction) {
            // Hope we will replace it with sentry in v2
        } else {
            localLogger[modificator](message, error);
        }
    }
    info(message: any, info?: any) {
        this.addEvent(MessageModificators.LOG, message, info);
    }
    warn(message: any, warn?: any) {
        this.addEvent(MessageModificators.WARNING, message, warn);
    }
    error(message: any, error?: any) {
        this.addEvent(MessageModificators.ERROR, message, error);
    }
    critical(message: any, error?: any) {
        this.addEvent(MessageModificators.CRITICAL, message, error);
    }
}

export default new Logger();
